import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, h2ms} from '@/utils/auth'
import { updateTrackHistoryByRoute } from '@/utils/track'
Vue.use(VueRouter)

/* Layout */
import Layout from '@/layout'
import { getTokenTime, setTokenTime, removeToken } from '../utils/auth'
import { tokenTimeout } from '../setting'
import {getSessionStorage, setSessionStorage} from "@/utils/session";
const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/display',
    children: [
      {
        path: 'display',
        component: () => import('@/views/display/index'),
        name: 'display',
        meta: { title: '产品列表', icon: 'dashboard', affix: true }
      },
      {
        path: 'apply',
        component: () => import('@/views/display/pages/Apply'),
        name: 'apply',
        meta: { title: '产品申请', icon: 'dashboard', affix: true }
      },
      {
        path: 'detail',
        component: () => import('@/views/display/pages/Detail'),
        name: 'detail',
        meta: { title: '产品详情', icon: 'dashboard', affix: true }
      },
      {
        path: 'profile',
        component: () => import('@/views/profile/index'),
        name: 'profile',
        meta: { title: '个人中心', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    // hidden: true
  },
  {
    path: '/get_back_password',
    name: 'get_back_password',
    component: () => import('@/views/login/pages/GetBackPD'),
    // hidden: true
  },
  {
    path: '/otherLogin',
    name: 'otherLogin',
    component: () => import('@/views/login/pages/OtherLogin'),
    // hidden: true
  },
  {
    path: '/phone_register',
    name: 'phone_register',
    component: () => import('@/views/login/pages/PhoneRegister'),
    // hidden: true
  },
  {
    path: '/explanatory',
    component: () => import('@/views/explanatory/index'),
    name: 'explanatory',
    meta: { title: '文本说明', icon: 'dashboard', affix: true }
  },
  {
    path: '/explanatoryapp',
    component: () => import('@/views/explanatoryapp/index'),
    name: 'explanatoryapp',
    meta: { title: '文本说明', icon: 'dashboard', affix: true }
  },
  {
    path: '/track-redirect',
    name: 'trackRedirect',
    component: () => import('@/views/track-redirect/index')
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const  queryParams= (hash)=>{
  let params = {};
  let queryStr = hash.split('?')[1];
  if(queryStr) {
    let paramList = queryStr.split('&');
    paramList.forEach(param => {
      params[param.split('=')[0]] = param.split('=')[1]
    });
  }
  if(params?.url){
    setSessionStorage('loginUrl',params?.url)
  }else{
    params.url = ''
    setSessionStorage('loginUrl','')
  }
  return params;
}

const whiteList = ['/login', '/get_back_password', '/phone_register', '/explanatory','/explanatoryapp', '/otherLogin', '/track-redirect'] // no redirect whitelist '/auth-redirect'
const passThroughWhiteList = ['/explanatory', '/explanatoryapp', '/otherLogin', '/track-redirect']

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken && hasToken !='null') {
    if(getTokenTime()) {
      let dateNow = Date.now();
      if((getTokenTime - dateNow) >= h2ms(tokenTimeout)) {
        Message({
          message: '登录失效,即将跳转登录页',
          type: 'error',
          duration: 3 * 1000
        })
        setTimeout(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }, 3000)
        return false;
      } else {
        setTokenTime(dateNow);
      }
    }
    // if (to.path === '/login') {
    if (whiteList.indexOf(to.path) !== -1 && passThroughWhiteList.indexOf(to.path) === -1) {
      // if is logged in, redirect to the home page
      if(to.path == '/get_back_password'){
        next()
      }else{
        const params = queryParams(location.hash)
        if(params?.logout){
          // console.log(to.path,'2345')
          removeToken()
          next({path: '/login'})
        }
        next({path: '/'})
      }

      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      const params = queryParams(location.hash)
      if(params?.url){
        const target = decodeURIComponent(params?.url) + '?token=' + hasToken
        window.location = target
      }
    if(params?.logout){
      removeToken()
      next({path: '/login'})
    }

      // determine whether the user has obtained his permission roles through getInfo
       const roles = store.state.user.noPayProject && store.state.user.noPayProject.length || store.state.user.yourProject && store.state.user.yourProject.length;

      if (roles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch('user/getInfo')

          // generate accessible routes map based on roles
          // const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

          // // dynamically add accessible routes
          // router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.path}`)
          next(`/login`)
          NProgress.done()
        }
      }
    }

    if(to.name == 'display') {
      store.commit('display/SET_ISDISPLAY', true);
    } else {
      store.commit('display/SET_ISDISPLAY', false);
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      // next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    let ele = document.querySelectorAll('.logo-box span')[0];
    if(to.name == 'display') {
      ele && ele.classList.add('hidden')
    } else {
      ele && ele.classList.remove('hidden')
    }

  }, 0)
  updateTrackHistoryByRoute(to, from)
  NProgress.done()
})


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
export default router
